import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fetchOrderDetails } from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectGuestOrderOrderRef,
  makeSelectOrderDetails,
  makeSelectSessionToken
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import { ORDER_ACTION_TYPES } from "utils/constants";
import SwitchToEsim from "./SwitchToEsim";
import isEmpty from "lodash/isEmpty";
import NotEligible from "../../../components/NotEligible";

const SwitchToEsimAction = props => {
  const {
    isFetchingOrderDetails,
    isSubmittingSwitchToEsim,
    orderDetails,
    token
  } = props;

  if (!token) {
    return <NotEligible />;
  }

  if (
    isFetchingOrderDetails ||
    isSubmittingSwitchToEsim ||
    isEmpty(orderDetails)
  ) {
    return <Spinner size={200} sx={styles.fullPage} />;
  }

  return <SwitchToEsim {...props} />;
};

const mapStateToProps = createStructuredSelector({
  orderRef: makeSelectGuestOrderOrderRef(),
  orderDetails: makeSelectOrderDetails(),
  isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
  token: makeSelectSessionToken(),
  isSubmittingSwitchToEsim: makeSelectIsFetchingData("submitReplaceSim")
});

export const mapDispatchToProps = dispatch => {
  return {
    fetchOrderDetails: orderRef => {
      const params = {
        type: ORDER_ACTION_TYPES.SWITCH_TO_ESIM,
        order_ref: orderRef
      };

      dispatch(fetchOrderDetails(params));
    }
  };
};

SwitchToEsimAction.defaultProps = {
  fetchOrderDetails: () => {}
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(SwitchToEsimAction);
